import { storyblokInit, apiPlugin, getStoryblokApi as sbApi } from "@storyblok/react";
import { components } from "@/utils/dynamic-components";

storyblokInit({
  accessToken: "7nWaGuEvUqOn1t56es7Degtt",
  use: [apiPlugin],
  components,
});

export { sbApi as getStoryblokApi };